import { Link, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const hideCategoryBar =
    location.pathname.startsWith("/products/") &&
    location.pathname !== "/products";

  // ✅ Close menu when clicking outside (excluding button)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="w-full bg-white border-b border-gray-200 font-coldiac">

      {/* ================= TOP NAV ================= */}
      <div
        className="
          mx-auto w-full px-[4vw] max-w-[1680px]
          h-[64px] sm:h-[72px]
          flex items-center justify-between
        "
      >
        {/* LOGO */}
        <Link to="/" className="flex items-center">
          <img
            src="/hero.svg"
            alt="Ola Candid Stitch"
            className="h-[34px] sm:h-[42px] lg:h-[46px] object-contain"
          />
        </Link>

        {/* DESKTOP LINKS */}
        <nav className="hidden lg:flex items-center gap-8 text-[20px] text-gray-800">
          <Link to="/" className="hover:text-black transition">Home</Link>
          <Link to="/products" className="hover:text-black transition">All Products</Link>
          <a
            href="https://www.instagram.com/candidstitch?igsh=YzFoeXBtZmxxdjE0"
            target="_blank"
            rel="noreferrer"
            className="hidden lg:inline hover:text-black transition"
          >
            Instagram
          </a>
          <a
            href="https://www.indiamart.com/candid-stitch"
            target="_blank"
            rel="noreferrer"
            className="hover:text-black transition"
          >
            Indiamart
          </a>
          <a
            href="https://wa.me/918080907304"
            target="_blank"
            rel="noreferrer"
            className="hover:text-black transition"
          >
            WhatsApp
          </a>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          ref={buttonRef}
          onClick={() => setMenuOpen((prev) => !prev)}
          className="lg:hidden text-2xl text-black"
        >
          ☰
        </button>
      </div>

      {/* ================= MOBILE MENU ================= */}
      {menuOpen && (
        <div
          ref={menuRef}
          className="lg:hidden border-t border-gray-200 bg-white"
        >
          <div className="flex flex-col px-6 py-4 gap-4 text-[18px]">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              Home
            </Link>

            <Link to="/products" onClick={() => setMenuOpen(false)}>
              All Products
            </Link>

            <a
              href="https://www.indiamart.com/candid-stitch"
              target="_blank"
              rel="noreferrer"
              onClick={() => setMenuOpen(false)}
            >
              Indiamart
            </a>

            <a
              href="https://wa.me/918080907304"
              target="_blank"
              rel="noreferrer"
              onClick={() => setMenuOpen(false)}
            >
              WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
